export default new class Archive {
	constructor() {
		this.selectors = {
			archiveButton: '.js-archive'
		};
	}

	init() {
		this.initArchive();
	}

	async updateArchiveView(archiveButton) {
		archiveButton.classList.toggle('active');
	}

	async sendArchiveRequest(articleId, action) {
		const data = new FormData();
		data.append('event', 'article_archive');
		data.append('article_id', articleId);
		data.append('action', action);

		try {
			await fetch(window.location.href, {
				method: 'POST',
				body: data,
				redirect: 'follow'
			});
		} catch (error) {
			console.error('Erreur lors de la mise à jour du like:', error);
			throw error;
		}
	}

	initArchive() {
		document.querySelectorAll(this.selectors.archiveButton).forEach(archiveButton => {
			archiveButton.addEventListener('click', async () => {
				try {
					const action = archiveButton.classList.contains('active') ? 'remove' : 'add';
					
					// Mise à jour optimiste de l'UI
					this.updateArchiveView(archiveButton);
					
					// Envoi de la requête au serveur
					await this.sendArchiveRequest(archiveButton.dataset.id, action);
				} catch (error) {
					// En cas d'erreur, on revient à l'état précédent
					this.updateArchiveView(archiveButton);
				}
			});
		});
	}
}